import { genericThunkCreator2 } from 'app/actions/genericActionCreator'

export const getAnnouncements = () => genericThunkCreator2('ANNOUNCEMENTS', `/lgyhub/api/announcements`)

export const createAnnouncement = (announcementRequest) => genericThunkCreator2('ANNOUNCEMENTS', `/lgyhub/api/announcements`, { method: 'POST', body: announcementRequest })

export const deleteAnnouncement = (announcementId) => genericThunkCreator2('ANNOUNCEMENTS', `/lgyhub/api/announcements/delete/${announcementId}`, { method: 'POST' })